<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="filter_header" :viewName="viewName" :view_filters="view_filters"
                        v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-row v-if="selectedItems && selectedItems.length > 0" class="mb-2 ml-1">
                        <v-col cols="auto" v-if="currentPath.includes('nhap-kho-tq') && !roleStoreTQ">
                            <v-btn color="primary" @click="changeStatusSelectedProducts">
                                <v-icon left>mdi-sync</v-icon>
                                Chuyển trạng thái ({{ selectedItems.length }})
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="success" @click="exportSelectedItems">
                                <v-icon left>mdi-download</v-icon>
                                Xuất Excel ({{ selectedItems.length }})
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="info" @click="openTruckDialog">
                                <v-icon left>mdi-truck</v-icon>
                                Xếp xe
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="blue" text-color="white" small>
                                <v-icon left small>mdi-package-variant-closed</v-icon>
                                {{ selectedItemsNumberOfPack | currency }} kiện
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="orange" text-color="white" small>
                                <v-icon left small>mdi-weight-kilogram</v-icon>
                                {{ selectedItemsWeight | currency('', 1) }} kg
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="green" text-color="white" small>
                                <v-icon left small>mdi-cube-outline</v-icon>
                                {{ selectedItemsVolume | currency('', 3) }} m³
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedItems"
                        fixed-header height="calc(100vh - 300px)">
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" :id="'r-' + item.ID"
                                :style="{ 'background-color': !item.Weight && !item.Volume ? '#fe545496' : '' }">
                                <td @click="select(!isSelected)"><v-checkbox primary hide-details
                                        :input-value="isSelected"></v-checkbox></td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.SaleName || '-' }}</td>
                                <td>
                                    <router-link :to="{ name: 'ProductDetail', params: { id: item.ID } }" target="_blank" style="text-decoration: none; font-weight: bold; color: #1976d2;" @click.native.stop>
                                        {{ item.BoxCode || 'Xem' }}
                                    </router-link>
                                </td>
                                <td>{{ item.PartnerName }}</td>
                                <td>{{ item.QuoteCount > 0 ? 'Đã có khai báo' : '' }}</td>
                                <td>{{ item.Note }}</td>
                                <td class="text-center">
                                    <div v-if="getFirstImage(item.Images)" style="width: 50px; height: 50px; display: inline-flex; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #eee; border-radius: 4px; padding: 2px;">
                                        <a :href="getFirstImage(item.Images)" target="_blank" @click.stop>
                                            <v-img :src="getFirstImage(item.Images)" max-width="46" max-height="46" contain></v-img>
                                        </a>
                                    </div>
                                    <div v-else class="grey--text text-caption">-</div>
                                </td>
                                <td>{{ item.ProductNameCN }}</td>
                                <td>{{ item.SuffixBill }}</td>
                                <td>
                                    <p v-html="item.OrderCodes"></p>
                                </td>
                                <td>
                                    <p v-html="item.BillCodes"></p>
                                </td>
                                <td class="text-right">
                                    <v-tooltip right color="grey lighten-3" transition="expand-transition"
                                        max-width="500">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on" v-if="currentPath.includes('ton-kho-tq')">{{
                                                ((item.NumberOfPack | 0) - (item.NumberOfPackTruck | 0)) | currency
                                                }}</span>
                                            <span v-on="on" v-else-if="currentPath.includes('ton-kho-vn')">{{
                                                ((item.NumberOfPackImport | 0) - (item.NumberOfPackExport | 0)) |
                                                currency
                                            }}</span>
                                            <span v-on="on" v-else>{{ item.NumberOfPack | currency }}</span>
                                        </template>
                                        <!-- Hiển thị lịch sử xuất hàng nếu currentPath là xuat-kho-vn -->
                                        <span v-if="currentPath.includes('xuat-kho-vn')">
                                            <v-list width="480" color="transparent" dense>
                                                <v-list-item>
                                                    <v-list-item-title class="font-weight-bold">Lịch sử xuất
                                                        hàng</v-list-item-title>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <template v-if="item.ExportHistory && item.ExportHistory.length > 0">
                                                    <v-list-item v-for="(history, idx) in item.ExportHistory"
                                                        :key="idx">
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ history.BillCode }} - {{
                                                                history.ExportDate | display_date('DD-MM-YYYY')
                                                            }}</v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                Số kiện: {{ history.NumberOfPack | currency }} |
                                                                Cân nặng: {{ history.Weight | currency('', 1) }} kg |
                                                                Thể tích: {{ history.Volume | currency('', 3) }} m³
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                                <v-list-item v-else>
                                                    <v-list-item-subtitle class="text-center grey--text">Chưa có lịch sử
                                                        xuất hàng</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>
                                                            Tổng kiện: {{ item.NumberOfPack | currency }} |
                                                            Đã xuất: {{ item.NumberOfPackExport | currency }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right"
                                    v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{
                                        item.NumberOfPackTruck | currency }}</td>
                                <td class="text-right"
                                    v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{
                                        (item.NumberOfPack - item.NumberOfPackTruck) | currency }}</td>
                                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                                <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                                <!-- Chi kho TQ: dòng 1 = thu khách, dòng 2 = chi gốc -->
                                <td class="text-right">
                                    <div>{{ item.Deposit | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ item.OtherCost | currency
                                    }}</div>
                                </td>
                                <!-- Cước vận chuyển: dòng 1 = thu khách, dòng 2 = chi gốc -->
                                <td class="text-right">
                                    <div>{{ item.TotalFeeWeight | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ item.TotalCostWeight |
                                        currency }}</div>
                                </td>
                                <!-- Chi phí chính ngạch: dòng 1 = thu khách, dòng 2 = chi gốc -->
                                <td class="text-right">
                                    <div>{{ item.AdditionalFeeAmount | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ item.AdditionalFeeCost |
                                        currency }}</div>
                                </td>
                                <!-- Tổng tiền: dòng 1 = tổng thu khách, dòng 2 = tổng chi gốc -->
                                <td class="text-right">
                                    <div>{{ (item.Deposit || 0) + (item.TotalFeeWeight || 0) + (item.AdditionalFeeAmount
                                        || 0) | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ (item.OtherCost || 0) +
                                        (item.TotalCostWeight || 0) +
                                        (item.AdditionalFeeCost || 0) | currency }}</div>
                                </td>
                                <!-- Lợi nhuận = Tổng thu - Tổng chi -->
                                <td class="text-right">{{ ((item.Deposit || 0) + (item.TotalFeeWeight || 0) +
                                    (item.AdditionalFeeAmount || 0)) -
                                    ((item.OtherCost || 0) + (item.TotalCostWeight || 0) + (item.AdditionalFeeCost ||
                                        0)) | currency }}</td>
                                <td class="text-center">
                                    <v-icon style="cursor: pointer;" medium
                                        :color="isDaoHDChecked(item) ? 'red' : 'gray'"
                                        @click="toggleDaoHD(item)">circle</v-icon>
                                </td>
                                <td class="text-center">
                                    <v-icon style="cursor: pointer;" medium :color="item.IsBack ? 'blue' : 'gray'"
                                        @click="toggleBack(item)">circle</v-icon>
                                </td>
                                <!-- <td class="text-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" medium :color="item.IsSplitTax ? 'red' : 'gray'" >circle</v-icon>
                                        </template>
                                        <span>{{ $t('table_headers.is_split_tax') }}</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon style="cursor: pointer;" v-on="on" medium :color="item.IsSentCustoms ? 'blue' : 'gray'" @click="saveItem({ ID: item.ID, IsSentCustoms: !item.IsSentCustoms })">circle</v-icon>
                                        </template>
                                        <span>{{$t('export.send_custom')}}</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon style="cursor: pointer;" v-on="on" medium :color="item.IsReady ? 'green' : 'gray'" @click="saveItem({ ID: item.ID, IsReady: !item.IsReady })">circle</v-icon>
                                        </template>
                                        <span>{{$t('table_headers.is_ready')}}</span>
                                    </v-tooltip>
                                </td> -->
                                <td>
                                    {{ item.ReceiveDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PackDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td>
                                    {{ item.StoreCNExpDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PaymentDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td v-if="(adminRole || csRole) && item.Status != product_status.xuat_du">
                                    <v-edit-dialog :return-value.sync="item.Status" large lazy persistent
                                        @save="saveItem({ ID: item.ID, Status: item.Status })">
                                        <div :style="{ 'color': display_color(item.Status, product_status_list) }">{{
                                            item.Status |
                                            display_value(product_status_list) }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.Status" :items="product_status_list"
                                                :item-text="p => p.i18n ? $t(p.i18n) : p.name" item-value="value"
                                                :label="$t('form.status')" class="ma-1">
                                            </v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else :style="{ 'color': display_color(item.Status, product_status_list) }">{{
                                    item.Status |
                                    display_value(product_status_list) }}</td>
                                <td>{{ item.StoreID | display_value(storages, 'ID', 'Name') }}</td>
                                <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                                <td class="text-center">
                                    <!-- Menu context to work with each row item -->
                                    <v-menu offset-y :ref="'contextMenu-' + item.ID">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="printLabel(item.QuoteID)" :disabled="!item.QuoteID">
                                                <v-list-item-icon>
                                                    <v-icon>print</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ $t('actions.print_label') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="editQuote(item.QuoteID)"
                                                :disabled="!item.QuoteID || item.QuoteID <= 0">
                                                <v-list-item-icon>
                                                    <v-icon>mdi-file-document-edit</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ $t('actions.edit_quote') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="openItem(item.ID)">
                                                <v-list-item-icon>
                                                    <v-icon>edit</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ $t('actions.edit') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="adminRole || (csRole && item.Status == 1)"
                                                @click="deleteItem(item.ID)">
                                                <v-list-item-icon>
                                                    <v-icon>delete</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ $t('actions.delete') }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template slot="body.append">
                            <tr v-if="summary" class="total-summary-td">
                                <td colspan="12" class="text-center font-weight-bold">Tổng</td>
                                <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold"
                                    v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{
                                        summary.NumberOfPackTruck | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold"
                                    v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{
                                        summary.NumberOfPackInTQ | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 1) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Volume | currency('', 3) }}</td>
                                <!-- Chi kho TQ summary -->
                                <td class="text-end font-weight-bold">
                                    <div>{{ summary.Deposit | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ summary.OtherCost |
                                        currency('', 2) }}</div>
                                </td>
                                <!-- Cước VT summary -->
                                <td class="text-end font-weight-bold">
                                    <div>{{ summary.TotalFeeWeight | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ summary.TotalCostWeight |
                                        currency }}</div>
                                </td>
                                <!-- Chi phí chính ngạch summary -->
                                <td class="text-end font-weight-bold">
                                    <div>{{ summary.AdditionalFeeAmount | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ summary.AdditionalFeeCost |
                                        currency }}</div>
                                </td>
                                <!-- Tổng tiền summary -->
                                <td class="text-end font-weight-bold">
                                    <div>{{ (summary.Deposit || 0) + (summary.TotalFeeWeight || 0) +
                                        (summary.AdditionalFeeAmount || 0) | currency }}</div>
                                    <div v-if="adminRole" class="text-caption grey--text">{{ (summary.OtherCost || 0) +
                                        (summary.TotalCostWeight || 0) + (summary.AdditionalFeeCost || 0) | currency }}
                                    </div>
                                </td>
                                <!-- Lợi nhuận summary -->
                                <td class="text-end font-weight-bold">{{ ((summary.Deposit || 0) +
                                    (summary.TotalFeeWeight || 0) + (summary.AdditionalFeeAmount || 0)) -
                                    ((summary.OtherCost || 0) + (summary.TotalCostWeight || 0) +
                                        (summary.AdditionalFeeCost || 0)) | currency }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/ma_van_don_mau.xlsx"
            @closePopup="dialogImport = false" @importFile="importFile"></upload-file>

        <!-- Export Options Dialog -->
        <v-dialog v-model="dialogExport" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.select_export_type') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="selectedItems && selectedItems.length > 0" color="info" text
                            icon="mdi-information" class="mb-3">
                            {{ $t('export.export_selected_items', { count: selectedItems.length }) }}
                        </v-alert>
                        <v-alert v-else color="warning" text icon="mdi-information" class="mb-3">
                            {{ $t('export.export_all_items') }}
                        </v-alert>
                        <v-radio-group v-model="selectedExportType">
                            <v-radio v-for="option in exportOptions" :key="option.value" :label="option.text"
                                :value="option.value"></v-radio>
                        </v-radio-group>
                        <v-checkbox v-if="selectedExportType === 'chinh_ngach_vi'" v-model="isSentCustoms"
                            :label="$t('export.send_custom')"></v-checkbox>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogExport = false">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="confirmExport">
                        {{ $t('actions.export_file') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Quote Edit Dialog -->
        <v-dialog v-model="dialogQuoteEdit" max-width="700px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.edit_quote_info') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="quoteEditForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editingQuote.BrandName" :label="$t('form.product_brand')"
                                        outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editingQuote.ProductCapacity"
                                        :label="$t('form.product_capacity')" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editingQuote.ProductMaterial"
                                        :label="$t('form.product_material')" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editingQuote.PackType" :label="$t('form.pack_type')" outlined
                                        dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editingQuote.ProductSize" :label="$t('form.product_size')"
                                        outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model.number="editingQuote.ProductNumber"
                                        :label="$t('form.total_product')" outlined dense type="number" min="0"
                                        step="1"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelQuoteEdit" :disabled="savingQuote">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="saveQuoteEdit" :loading="savingQuote">
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Truck Creation Dialog -->
        <v-dialog v-model="dialogTruck" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.create_truck') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="truckForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="newTruck.LicensePlate" label="Biển số xe"
                                        :rules="[v => !!v || 'Biển số xe là bắt buộc']" required outlined
                                        dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select v-model="newTruck.Status" :items="receive_type_list" item-text="name"
                                        item-value="value" label="Trạng thái" outlined dense></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-alert color="info" text icon="mdi-information" class="mb-0">
                                        Sẽ tạo xe với {{selectedItems.filter(item => !item.OrderCodes).length}} sản
                                        phẩm chưa
                                        xếp xe
                                        <span v-if="selectedItems.filter(item => item.OrderCodes).length > 0">
                                            <br />(Đã loại bỏ {{selectedItems.filter(item => item.OrderCodes).length}}
                                            sản
                                            phẩm đã được xếp xe)
                                        </span>
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="cancelTruckCreation" :disabled="savingTruck">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="saveTruck" :loading="savingTruck">
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid } from "@/commons/utils";
import { print_quote_label } from "@/commons/hpod";
import upload_file from "@/components/popups/upload_file";
import { display_color } from "@/commons/formater"
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file,
    },
    data() {
        return {
            viewName: "product_list",
            view_filters: [],
            dialogImport: false,
            dialogExport: false,
            dialogQuoteEdit: false,
            savingQuote: false,
            dialogTruck: false,
            savingTruck: false,
            newTruck: {
                LicensePlate: '',
                Status: 1, // Xếp xe
                Products: []
            },
            editingQuote: {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            },
            selectedExportType: 'tieu_ngach',
            isSentCustoms: 0,
            selectedItems: [],
            product_status_list: configs.PRODUCT_STATUS_LIST,
            product_status: configs.PRODUCT_STATUS,
            receive_type_list: configs.RECEIVE_TYPE_LIST,
            receive_type: configs.RECEIVE_TYPE,
            pagination: { ...configs.PAGINATION },
            items_per_page: { ...configs.ITEMS_PER_PAGE },
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        currentPath() {
            this.view_filters = [];
            this.filterConditions = [];
            this.quickFilterConditions = [];
            this.filter_data();
        },
        storages() {
            let header_item = _.find(this.headers, { value: "StoreID" });
            if (header_item) {
                header_item.values =
                    _.map(this.storages, (item) => {
                        return {
                            value: item.ID,
                            name: item.Name,
                        };
                    }) || [];
            }
        },
        product_types() {
            let header_item = _.find(this.headers, { value: "ProductType" });
            if (header_item) {
                header_item.values =
                    _.map(this.product_types, (item) => {
                        return {
                            value: item.ID,
                            name: item.Name,
                        };
                    }) || [];
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.product.all.data,
            total_rows: state => state.product.all.total,
            summary: state => state.product.all.summary,
            loading: state => state.product.loading,
            storages: state => state.storage.all.data,
            product_types: state => state.productType.all.data,
        }),
        staffStorage() {
            return this.$store.state.authentication.user.storageid;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
        },
        csRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
        },
        roleStoreTQ() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Store;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        currentPath() {
            return this.$route.path !== undefined && this.$route.path ? this.$route.path : '';
        },
        isNoneOwner() {
            return this.currentPath.includes('hang-khong-ten');
        },
        selectedItemsWeight() {
            return this.selectedItems.reduce((total, item) => total + (parseFloat(item.Weight) || 0), 0);
        },
        selectedItemsVolume() {
            return this.selectedItems.reduce((total, item) => total + (parseFloat(item.Volume) || 0), 0);
        },
        selectedItemsNumberOfPack() {
            return this.selectedItems.reduce((total, item) => total + (parseInt(item.NumberOfPack) || 0), 0);
        },
        headers() {
            let baseHeaders = [
                {
                    text: this.$t('table_headers.customer_code'),
                    value: "CustomerName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.sale_staff'),
                    value: "SaleName",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.box_code'),
                    value: "BoxCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.partner_name'),
                    value: "PartnerName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'Khai báo',
                    value: "QuoteCount",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.note'),
                    value: "Note",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'Hình ảnh',
                    value: "Images",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.product_name_cn'),
                    value: "ProductNameCN",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.suffix_bill'),
                    value: "SuffixBill",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.license_plate'),
                    value: "OrderCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.bill_codes'),
                    value: "BillCodes",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn') ? this.$t('table_headers.remaining_pack') : this.$t('table_headers.number_of_pack'),
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Kiện xếp xe',
                    value: "NumberOfPackTruck",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Kiện tồn TQ',
                    value: "NumberOfPack - NumberOfPackTruck",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.weight'),
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.volume'),
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Chi kho TQ',
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Cước vận chuyển',
                    value: "TotalFeeWeight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Chi phí chính ngạch',
                    value: "ImportTaxAmount",
                    align: "end",
                    sortable: false,
                    filterable: false,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Tổng tiền',
                    value: "TotalAmount",
                    align: "end",
                    sortable: false,
                    filterable: false,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Lợi nhuận',
                    value: "TotalProfit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Đảo HĐ',
                    value: "IsSplitTax",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: 'Đã back',
                    value: "IsBack",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    dataType: configs.DATA_TYPE["Enum"]
                }
            ];
            // Xóa 2 cột Số kiện xếp xe và Số kiện tồn kho TQ nếu đang ở trang tồn kho TQ hoặc tồn kho VN
            if (this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn')) {
                baseHeaders = baseHeaders.filter(header => header.value !== "NumberOfPackTruck" && header.value !== "NumberOfPack - NumberOfPackTruck");
            }

            // Thêm các cột còn lại
            baseHeaders.push(
                // {
                //     text: this.$t('table_headers.is_split_tax'),
                //     value: "IsSplitTax",
                //     width: "60px",
                //     filterable: true,
                //     values: [
                //         { value: 1, name: this.$t('form.yes') },
                //         { value: 0, name: this.$t('form.no') }
                //     ],
                //     dataType: configs.DATA_TYPE["Enum"]
                // },
                {
                    text: this.$t('table_headers.receive_date'),
                    value: "ReceiveDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.deliver_date'),
                    value: "StoreCNExpDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.status'),
                    value: "Status",
                    filterable: true,
                    values: configs.PRODUCT_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.store_id'),
                    value: "StoreID",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.product_type'),
                    value: "ProductType",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    width: "80px"
                }
            );

            return baseHeaders;
        },
        filter_status() {
            return this.$route.meta && this.$route.meta.package_status ? this.$route.meta.package_status : [];
        },
        exportOptions() {
            return [
                { value: 'tieu_ngach', text: this.$t('form.export_tieu_ngach') },
                { value: 'chinh_ngach', text: this.$t('form.export_chinh_ngach') },
                { value: 'chinh_ngach_vi', text: this.$t('form.export_chinh_ngach_vi') },
            ];
        },
        filter_header() {
            let tmp = [...this.headers];
            tmp.push({
                text: this.$t('export.send_custom'),
                value: "IsSentCustoms",
                filterable: true,
                values: [{ value: 1, name: 'Yes' }, { value: 0, name: 'No' }],
                dataType: configs.DATA_TYPE["Enum"]
            });
            return tmp;
        }
    },
    methods: {
        display_color,
        getFirstImage(imagesString) {
            if (!imagesString) return null;
            try {
                let images = typeof imagesString === 'string' ? JSON.parse(imagesString) : imagesString;
                if (images && images.length > 0) {
                    return images[0].url || images[0].thumbUrl || images[0];
                }
            } catch (e) {
                return null;
            }
            return null;
        },
        hasInvoiceOrderValue(item) {
            if (!item) return false;
            return [
                Number(item.InvoiceQuantity || 0),
                Number(item.InvoiceUnitPrice || 0),
                Number(item.InvoiceTotalAmount || 0),
                Number(item.InvoiceVatRate || 0),
                Number(item.InvoiceTotalAfterVat || 0),
                Number(item.ProductAmount || 0),
                Number(item.VatTaxRate || 0),
            ].some(v => v > 0);
        },
        isDaoHDChecked(item) {
            return !!(item && (item.IsSplitTax || this.hasInvoiceOrderValue(item)));
        },
        toggleDaoHD(item) {
            if (!item || !item.ID) return;

            if (this.hasInvoiceOrderValue(item)) {
                if (!item.IsSplitTax) {
                    this.saveItem({ ID: item.ID, IsSplitTax: 1 });
                }
                return;
            }

            this.saveItem({ ID: item.ID, IsSplitTax: !item.IsSplitTax });
        },
        toggleBack(item) {
            if (!item || !item.ID) return;
            if (!item.IsBack && !item.BackBillImage) {
                sendErrorNotice('Vui lòng vào chi tiết mã hàng để upload ảnh bill thanh toán trước khi tick Đã back');
                return;
            }
            this.saveItem({ ID: item.ID, IsBack: !item.IsBack });
        },
        changeStatusSelectedProducts() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn sản phẩm để chuyển trạng thái!');
                return;
            }
            // Ví dụ: chuyển trạng thái sang "Đã giao" (Status = 3)
            const ids = this.selectedItems.map(item => item.ID);
            // Có thể mở dialog chọn trạng thái, ở đây demo cứng Status = 3
            // nhap_kho_tq: 1,
            // cho_xep_xe: 2,
            // xep_xe: 3,
            // cho_thong_quan_tq: 4,
            // kiem_hoa: 5,
            // cho_thong_quan_vn: 6,
            // nhap_kho_vn: 7,
            // xuat_thieu: 8,
            // xuat_du: 9
            let nextStatus = this.product_status.cho_xep_xe;
            const payload = { ids, Status: nextStatus };
            this.$store.dispatch("product/setDetail", { data: payload, id: ids[0] })
                .then(() => {
                    // this.selectedItems = [];
                    sendSuccessNotice('Chuyển trạng thái thành công!');
                })
                .catch(() => {
                    sendErrorNotice('Có lỗi khi chuyển trạng thái!');
                });
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            if (this.currentPath.includes('hang-khong-ten')) {
                param.filter.push({
                    column: "UID",
                    value: 0,
                    condition: "equal",
                });
                param.action = "hang-khong-ten";
            }
            if (this.filter_status && this.filter_status.length > 0) {
                param.filter.push({
                    column: "Status",
                    value: this.filter_status,
                    condition: "in",
                });
            }
            if (this.currentPath.includes('ton-kho-tq')) {
                param.action = "ton-kho-tq";
            }
            else if (this.currentPath.includes('ton-kho-vn')) {
                param.action = "ton-kho-vn";
            }
            this.$store.dispatch("product/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        printLabel(quote_id) {
            this.$store.dispatch("quote/getDetail", quote_id).then((quoteItem) => {
                print_quote_label(quoteItem);
            });
        },
        editQuote(quoteId) {
            if (!quoteId || quoteId <= 0) {
                sendErrorNotice(this.$t('errors.product_no_quote'));
                return;
            }

            // Load thông tin khai báo từ API
            this.$store.dispatch("quote/getDetail", quoteId).then((quoteItem) => {
                this.editingQuote = {
                    ID: quoteItem.ID || quoteId,
                    BrandName: quoteItem.BrandName || '',
                    ProductCapacity: quoteItem.ProductCapacity || '',
                    ProductMaterial: quoteItem.ProductMaterial || '',
                    PackType: quoteItem.PackType || '',
                    ProductSize: quoteItem.ProductSize || '',
                    ProductNumber: quoteItem.ProductNumber || 0
                };
                this.dialogQuoteEdit = true;
            }).catch(error => {
                console.error('Error loading quote:', error);
                sendErrorNotice(this.$t('errors.cannot_load_quote_info'));
            });
        },
        cancelQuoteEdit() {
            this.dialogQuoteEdit = false;
            this.resetEditingQuote();
        },
        resetEditingQuote() {
            this.editingQuote = {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            };
        },
        async saveQuoteEdit() {
            if (!this.$refs.quoteEditForm.validate()) {
                return;
            }

            this.savingQuote = true;

            try {
                const updateData = {
                    BrandName: this.editingQuote.BrandName,
                    ProductCapacity: this.editingQuote.ProductCapacity,
                    ProductMaterial: this.editingQuote.ProductMaterial,
                    PackType: this.editingQuote.PackType,
                    ProductSize: this.editingQuote.ProductSize,
                    ProductNumber: this.editingQuote.ProductNumber
                };

                await this.$store.dispatch("quote/setDetail", {
                    data: updateData,
                    id: this.editingQuote.ID
                });

                sendSuccessNotice(this.$t('success.quote_updated'));
                this.dialogQuoteEdit = false;
                this.resetEditingQuote();

                // Refresh danh sách sản phẩm để hiển thị thông tin mới
                this.filter_data();

            } catch (error) {
                console.error('Error updating quote:', error);
                sendErrorNotice(this.$t('errors.cannot_update_quote'));
            } finally {
                this.savingQuote = false;
            }
        },
        openItem: function (id) {
            if (!id) {
                this.$router.push({ name: 'ProductDetail', params: { id: 'new' } });
            }
            else {
                this.$router.push({ name: 'ProductDetail', params: { id: id } });
            }
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        saveItem(item) {
            this.$store.dispatch("product/setDetail", { data: item, id: item.ID });
        },
        importFileDialog() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for (const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("product/import_data", formData);
            }
            this.dialogImport = false;
        },
        exportData() {
            // Show export options dialog
            this.dialogExport = true;
        },
        exportSelectedItems() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm để xuất Excel!');
                return;
            }
            // Show export options dialog cho selected items
            this.dialogExport = true;
        },
        confirmExport() {
            var param = {
                exportType: this.selectedExportType
            };

            const hasSelectedItems = this.selectedItems && this.selectedItems.length > 0;

            // Nếu có selected items thì export theo selection, ngược lại export theo filter
            if (hasSelectedItems) {
                // Export theo selected items
                param.selectedIds = this.selectedItems.map(item => item.ID);
            } else {
                // Export theo filter như cũ
                param.pagination = this.pagination;
                param.filter = this.filterConditions;
                param.quickFilter = this.quickFilterConditions;
            }

            param.isSentCustoms = this.isSentCustoms ? 1 : 0;

            this.dialogExport = false;

            // Choose the appropriate export function based on selection
            const exportPromise = this.selectedExportType === 'tieu_ngach'
                ? this.$store.dispatch("product/exportTieuNgach", param) : this.selectedExportType === 'chinh_ngach' ?
                    this.$store.dispatch("product/exportChinhNgach", param)
                    : this.$store.dispatch("product/exportChinhNgachVi", param);

            // exportPromise.then(() => {
            //     // Clear selection sau khi export thành công
            //     if (hasSelectedItems) {
            //         this.selectedItems = [];
            //         this.filter_data();
            //     }
            // }).catch(error => {
            //     console.error('Export error:', error);
            // });
        },
        loadQuotesByCustomer(customerId) {
            if (!customerId) {
                this.availableQuotes = [];
                return;
            }

            this.loadingQuotes = true;
            this.$store.dispatch("quote/getQuotesByCustomer", customerId)
                .then(quotes => {
                    this.availableQuotes = quotes || [];
                })
                .catch(error => {
                    console.error('Error loading quotes:', error);
                    this.availableQuotes = [];
                })
                .finally(() => {
                    this.loadingQuotes = false;
                });
        },
        onCustomerChange() {
            // Reset quote khi khách hàng thay đổi
            this.currentItem.QuoteID = null;
            if (this.currentItem.UID) {
                this.loadQuotesByCustomer(this.currentItem.UID);
            } else {
                this.availableQuotes = [];
            }
        },
        quoteFilter(item, queryText, itemText) {
            if (!queryText) return true;

            const searchText = queryText.toLowerCase();
            const hsCode = (item.HsCode || '').toLowerCase();
            const productInfo = (item.ProductInfo || '').toLowerCase();

            return hsCode.includes(searchText) || productInfo.includes(searchText);
        },
        openTruckDialog() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm để xếp xe!');
                return;
            }

            // Chỉ lấy các sản phẩm chưa được xếp xe (OrderCodes là null hoặc rỗng)
            const unassignedItems = this.selectedItems.filter(item => !item.OrderCodes);

            if (unassignedItems.length === 0) {
                sendErrorNotice('Tất cả sản phẩm đã chọn đã được xếp xe rồi!');
                return;
            }

            // Hiển thị thông báo nếu có sản phẩm đã được xếp xe
            const assignedCount = this.selectedItems.length - unassignedItems.length;
            if (assignedCount > 0) {
                sendSuccessNotice(`Đã loại bỏ ${assignedCount} sản phẩm đã được xếp xe. Còn ${unassignedItems.length} sản phẩm có thể xếp xe.`);
            }

            this.dialogTruck = true;
        },
        cancelTruckCreation() {
            this.dialogTruck = false;
            this.resetNewTruck();
        },
        resetNewTruck() {
            this.newTruck = {
                LicensePlate: '',
                Status: 1, // Xếp xe
                Products: []
            };
        },
        async saveTruck() {
            if (!this.$refs.truckForm.validate()) {
                return;
            }

            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm!');
                return;
            }

            // Chỉ lấy các sản phẩm chưa được xếp xe (OrderCodes là null hoặc rỗng)
            const unassignedItems = this.selectedItems.filter(item => !item.OrderCodes);

            if (unassignedItems.length === 0) {
                sendErrorNotice('Không có sản phẩm nào chưa được xếp xe!');
                return;
            }

            this.savingTruck = true;

            try {
                const truckData = {
                    LicensePlate: this.newTruck.LicensePlate,
                    Status: this.newTruck.Status,
                    Products: unassignedItems.map(item => item.ID)
                };

                const result = await this.$store.dispatch("order/setDetail", {
                    data: truckData,
                    id: 0
                });

                sendSuccessNotice('Tạo xe hàng thành công!');
                this.dialogTruck = false;
                this.resetNewTruck();
                this.selectedItems = [];

                // Refresh danh sách sản phẩm
                this.filter_data();

                // Chuyển đến trang chi tiết xe nếu muốn
                if (result && result.ID) {
                    const shouldNavigate = confirm('Xe hàng đã được tạo. Bạn có muốn xem chi tiết xe không?');
                    if (shouldNavigate) {
                        this.$router.push({ name: 'TruckDetail', params: { Pid: result.ID } });
                    }
                }

            } catch (error) {
                console.error('Error creating truck:', error);
                sendErrorNotice('Có lỗi khi tạo xe hàng!');
            } finally {
                this.savingTruck = false;
            }
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$store.dispatch("storage/getList");
        this.$store.dispatch("productType/getList");
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("product/removeDetail", id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
        this.selectedItems = [];
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_IMPORT_ACTION");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
<style scoped>
.thumbnail-img {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s;
}

.thumbnail-img:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}
</style>